export default "__VITE_ASSET__BgD3_7f4__"